// extracted by mini-css-extract-plugin
export default {"root":"Log_root__PE3bE","log":"Log_log__fxNqS","animate":"Log_animate__VzL4A"};